<template>
    <div class="byb-wrapper w-100">

        <!-- BANNER -->
        <div class="byb-banner" v-if="step === 'banner'" @click="step = 'config'">
            <div class="banner-content d-flex align-items-center justify-content-between">
                <div class="banner-text">
                    <h2 class="banner-title">
                        <span class="title-line">PA'</span>
                        <span class="title-line">TODOS</span>
                    </h2>
                    <p class="banner-sub">Pollo para compartir en grande</p>
                    <span class="banner-price">${{ BOX_INFO.price }}</span>
                </div>
                <div class="banner-img-wrap">
                    <img :src="bannerImg" alt="Caja Pa' Todos" class="banner-img">
                </div>
            </div>
            <button class="btn-configure">¡Arma tu Caja!</button>
        </div>

        <!-- BUILDER -->
        <div class="byb-builder" v-if="step !== 'banner'">

            <button class="btn-close-builder" @click="resetAll">✕</button>

            <div class="builder-split d-flex flex-wrap flex-md-nowrap">

                <!-- IZQUIERDA: Caja visual -->
                <div class="builder-left">
                    <div class="box-top">

                        <div class="size-badge-row">
                            <span class="size-badge">Caja Familiar</span>
                            <span class="size-price">${{ BOX_INFO.price }}</span>
                        </div>

                        <!-- Caja visual — siempre 3 tercios -->
                        <div class="box-visual">
                            <div
                                class="box-section third"
                                :class="slots[i] ? 'filled' : 'empty'"
                                v-for="(slot, i) in slots"
                                :key="i"
                            >
                                <template v-if="slot">
                                    <img :src="products[slot].boxImage" class="section-product-img">
                                    <span class="section-label">{{ products[slot].shortName }}</span>
                                    <span class="section-qty">{{ products[slot].slotQty }} {{ products[slot].unitLabelPlural }}</span>
                                    <span class="section-variant-badge" v-if="slotVariants[i] === 'spicy'">🌶️</span>
                                </template>
                                <template v-else>
                                    <span class="section-slot-number">{{ i + 1 }}</span>
                                    <span class="section-empty-text">Elige</span>
                                </template>
                            </div>
                        </div>

                        <div class="includes-row">
                            <span class="includes-label">Incluye:</span>
                            <span class="includes-text">{{ BOX_INFO.includes }}</span>
                        </div>
                    </div>
                    <div class="builder-left-footer">
                        <button class="btn-reset-link" @click="resetAll">Empezar de nuevo</button>
                    </div>
                </div><!-- /builder-left -->

                <!-- DERECHA: Pasos -->
                <div class="builder-right">
                    <div class="box-bottom">

                        <!-- PASO: Configurar tercios -->
                        <template v-if="step === 'config'">
                            <h3 class="step-title">Arma tu Caja</h3>
                            <p class="step-sub">Elige qué va en cada tercio</p>

                            <div class="tercios-list">
                                <div class="tercio-row" v-for="(slot, i) in slots" :key="i">
                                    <span class="tercio-label">Tercio {{ i + 1 }}</span>
                                    <div class="tercio-options">
                                        <button
                                            class="tercio-pill"
                                            v-for="pk in productKeys"
                                            :key="pk"
                                            :class="{ active: slots[i] === pk }"
                                            @click="selectSlot(i, pk)"
                                        >
                                            <img :src="products[pk].image" class="pill-img">
                                            <span class="pill-name">{{ products[pk].shortName }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <button
                                class="btn-next mt-4"
                                :disabled="!allSlotsSelected"
                                @click="step = 'variant'"
                            >Normal o Spicy →</button>
                        </template>

                        <!-- PASO: Variante -->
                        <template v-if="step === 'variant'">
                            <h3 class="step-title">¿Normal o Spicy?</h3>
                            <p class="step-sub">Elige para cada tercio</p>

                            <div class="variant-list d-flex flex-column gap-3">
                                <div class="variant-row-item" v-for="(slot, i) in slots" :key="i">
                                    <div class="variant-protein d-flex align-items-center gap-2 mb-2">
                                        <img :src="products[slot].image" class="variant-mini-img">
                                        <span class="variant-tercio-label">Tercio {{ i + 1 }}</span>
                                        <span class="variant-protein-name">{{ products[slot].shortName }}</span>
                                        <span class="variant-qty-badge">{{ products[slot].slotQty }} {{ products[slot].unitLabelPlural }}</span>
                                    </div>
                                    <div class="d-flex gap-2">
                                        <button
                                            class="variant-pill"
                                            :class="{ active: slotVariants[i] === 'normal' }"
                                            @click="setVariant(i, 'normal')"
                                        >Normal</button>
                                        <button
                                            class="variant-pill spicy"
                                            :class="{ active: slotVariants[i] === 'spicy' }"
                                            @click="setVariant(i, 'spicy')"
                                        >🌶️ Spicy</button>
                                    </div>
                                </div>
                            </div>

                            <button class="btn-next mt-4" @click="step = 'summary'">Ver resumen →</button>
                            <button class="btn-back mt-2" @click="step = 'config'">← Cambiar tercios</button>
                        </template>

                        <!-- PASO: Resumen -->
                        <template v-if="step === 'summary'">
                            <h3 class="step-title">Tu Caja</h3>

                            <div class="summary-size-row d-flex justify-content-between align-items-center mb-3">
                                <span class="summary-size-label">Caja Familiar</span>
                                <span class="summary-price">${{ BOX_INFO.price }}</span>
                            </div>

                            <div class="summary-list">
                                <div class="summary-row d-flex align-items-center gap-2" v-for="(p, i) in summaryProteins" :key="i">
                                    <img :src="products[p.product].image" class="summary-thumb">
                                    <div class="flex-fill">
                                        <span class="summary-product">{{ products[p.product].name }}</span>
                                        <span v-if="p.variant === 'spicy'" class="summary-spicy">🌶️ Spicy</span>
                                        <span class="summary-qty d-block">{{ p.qty }} {{ products[p.product].unitLabelPlural }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="summary-includes">
                                <span class="includes-label">Incluye:</span> {{ BOX_INFO.includes }}
                            </div>

                            <button class="btn-cart mt-3">🛒 Agregar al Carrito</button>
                            <button class="btn-back mt-2" @click="step = 'variant'">← Cambiar opciones</button>
                        </template>

                    </div>
                </div><!-- /builder-right -->

            </div><!-- /builder-split -->
        </div>
    </div>
</template>

<script>
const PRODUCTS = {
    big_mary: {
        name: "Big Mary's",
        shortName: "Big Mary's",
        unitLabel: 'sándwich',
        unitLabelPlural: 'sándwiches',
        slotQty: 3,
        image: require('@/assets/images/products/mx/big-mary-single.png'),
        boxImage: require('@/assets/images/box/big-mary.png'),
    },
    tenders: {
        name: 'Tenders',
        shortName: 'Tenders',
        unitLabel: 'tender',
        unitLabelPlural: 'tenders',
        slotQty: 15,
        image: require('@/assets/images/products/mx/pop-ins-masked.png'),
        boxImage: require('@/assets/images/box/tenders.png'),
    },
    signature: {
        name: 'Signature Chicken',
        shortName: 'Piezas',
        unitLabel: 'pieza',
        unitLabelPlural: 'piezas',
        slotQty: 8,
        image: require('@/assets/images/products/signature-chicken.png'),
        boxImage: require('@/assets/images/box/bone-chicken.png'),
    },
};

const BOX_INFO = {
    price: 799,
    includes: 'Puré Grande y Ensalada Grande',
};

export default {
    name: 'BuildYourBox',
    data() {
        return {
            step: 'banner',
            slots: [null, null, null],
            slotVariants: ['normal', 'normal', 'normal'],
            products: PRODUCTS,
            productKeys: Object.keys(PRODUCTS),
            BOX_INFO,
            bannerImg: require('@/assets/images/products/mx/combos-category.png'),
        };
    },
    computed: {
        allSlotsSelected() {
            return this.slots.every(s => s !== null);
        },
        summaryProteins() {
            const groups = {};
            this.slots.forEach((s, i) => {
                if (!s) return;
                const key = `${s}_${this.slotVariants[i]}`;
                if (!groups[key]) groups[key] = { product: s, variant: this.slotVariants[i], qty: 0 };
                groups[key].qty += PRODUCTS[s].slotQty;
            });
            return Object.values(groups);
        },
    },
    methods: {
        selectSlot(index, product) {
            const updated = [...this.slots];
            updated[index] = product;
            this.slots = updated;
        },
        setVariant(index, value) {
            const updated = [...this.slotVariants];
            updated[index] = value;
            this.slotVariants = updated;
        },
        resetAll() {
            this.step = 'banner';
            this.slots = [null, null, null];
            this.slotVariants = ['normal', 'normal', 'normal'];
        },
    },
};
</script>

<style scoped>
/* ========== WRAPPER ========== */
.byb-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px;
}

/* ========== BANNER ========== */
.byb-banner {
    background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
    border-radius: 20px;
    padding: 40px 32px 28px;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.byb-banner:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}
.banner-title {
    margin: 0 0 8px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.title-line {
    display: block;
    font-size: 48px;
    font-weight: 900;
    color: #fff;
    letter-spacing: 3px;
    line-height: 1;
    -webkit-text-stroke: 3px #000;
    text-stroke: 3px #000;
    paint-order: stroke fill;
}
.banner-sub {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.55);
    margin: 8px 0 12px;
}
.banner-price {
    font-size: 28px;
    font-weight: 800;
    color: var(--primary);
}
.banner-img-wrap { flex-shrink: 0; }
.banner-img {
    height: 130px;
    object-fit: contain;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
}
.btn-configure {
    display: block;
    width: 100%;
    margin-top: 20px;
    padding: 16px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 17px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.2s;
}
.btn-configure:hover { background: var(--vigequinary); }

/* ========== BUILDER ========== */
.byb-builder {
    background: #fff;
    border-radius: 20px;
    border: 2px solid var(--nonagenary);
    overflow: hidden;
    position: relative;
    animation: builderOpen 0.35s ease;
}
@keyframes builderOpen {
    0% { opacity: 0; transform: scale(0.96); }
    100% { opacity: 1; transform: scale(1); }
}
.btn-close-builder {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.08);
    color: var(--text9);
    font-size: 15px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ========== SPLIT LAYOUT ========== */
.builder-split { min-height: 380px; }
.builder-left {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.builder-right { width: 100%; }
@media (min-width: 768px) {
    .builder-left {
        width: 42%;
        border-right: 2px solid var(--nonagenary);
        min-height: 100%;
        justify-content: space-between;
    }
    .builder-right { width: 58%; }
    .builder-split { align-items: stretch; }
}

/* ========== CAJA VISUAL ========== */
.box-top {
    background: linear-gradient(145deg, #f9f5f0, #efe6da);
    padding: 16px 16px 12px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.size-badge-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.size-badge {
    font-size: 13px;
    font-weight: 700;
    color: var(--text9);
    background: rgba(255, 255, 255, 0.7);
    border-radius: 20px;
    padding: 3px 10px;
}
.size-price {
    font-size: 22px;
    font-weight: 800;
    color: var(--primary);
}
.box-visual {
    background: linear-gradient(145deg, #d4a574, #c4956a);
    border-radius: 14px;
    padding: 6px;
    gap: 4px;
    min-height: 130px;
    flex: 1;
    display: flex;
    box-shadow: 0 4px 16px rgba(150, 100, 50, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.box-section {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 4px;
    position: relative;
    transition: all 0.3s ease;
}
.box-section.third { flex: 1; }
.box-section.empty {
    background: rgba(255, 255, 255, 0.15);
    border: 2px dashed rgba(255, 255, 255, 0.3);
}
.box-section.filled {
    background: rgba(255, 255, 255, 0.65);
    animation: sectionFill 0.4s ease;
}
@keyframes sectionFill {
    0% { opacity: 0; transform: scale(0.88); }
    60% { transform: scale(1.03); }
    100% { opacity: 1; transform: scale(1); }
}
.section-product-img {
    height: 52px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
}
.section-label {
    font-size: 10px;
    font-weight: 700;
    color: var(--text9);
    margin-top: 3px;
    text-align: center;
    line-height: 1.2;
}
.section-qty {
    font-size: 10px;
    color: var(--text11);
    font-weight: 600;
}
.section-variant-badge {
    font-size: 12px;
    position: absolute;
    top: 4px;
    right: 4px;
}
.section-slot-number {
    font-size: 18px;
    font-weight: 900;
    color: rgba(255, 255, 255, 0.4);
    line-height: 1;
}
.section-empty-text {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.4);
    font-weight: 600;
    margin-top: 2px;
}
.includes-row {
    margin-top: 10px;
    font-size: 12px;
    color: var(--text9);
}
.includes-label {
    font-weight: 700;
    color: var(--text9);
    margin-right: 4px;
}
.includes-text { color: var(--text11); }

/* ========== CONTENIDO ========== */
.box-bottom {
    padding: 20px 16px 24px;
}
.step-title {
    font-size: 18px;
    font-weight: 800;
    color: var(--text3);
    margin: 0 0 4px;
    text-align: center;
}
.step-sub {
    font-size: 13px;
    color: var(--text11);
    text-align: center;
    margin: 0 0 16px;
}

/* ========== TERCIOS ========== */
.tercios-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.tercio-row {
    display: flex;
    align-items: center;
    gap: 10px;
}
.tercio-label {
    font-size: 12px;
    font-weight: 700;
    color: var(--text9);
    white-space: nowrap;
    min-width: 60px;
}
.tercio-options {
    display: flex;
    gap: 6px;
    flex: 1;
}
.tercio-pill {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 4px;
    border: 2px solid var(--nonagenary);
    border-radius: 12px;
    background: #fff;
    cursor: pointer;
    transition: all 0.18s ease;
}
.tercio-pill:hover {
    border-color: var(--primary);
    box-shadow: 0 2px 8px rgba(232, 118, 43, 0.12);
}
.tercio-pill.active {
    border-color: var(--primary);
    background: rgba(232, 118, 43, 0.07);
    box-shadow: 0 0 0 2px rgba(232, 118, 43, 0.15);
}
.pill-img {
    width: 36px;
    height: 28px;
    object-fit: contain;
}
.pill-name {
    font-size: 10px;
    font-weight: 700;
    color: var(--text9);
    text-align: center;
    line-height: 1.2;
}
.tercio-pill.active .pill-name { color: var(--primary); }

/* ========== VARIANTE ========== */
.variant-list { margin-bottom: 4px; }
.variant-row-item {
    padding: 12px;
    background: var(--octagenary);
    border-radius: 12px;
}
.variant-mini-img {
    width: 34px;
    height: 26px;
    object-fit: contain;
}
.variant-tercio-label {
    font-size: 11px;
    font-weight: 700;
    color: var(--text11);
    background: rgba(0,0,0,0.07);
    border-radius: 20px;
    padding: 2px 8px;
    white-space: nowrap;
}
.variant-protein-name {
    font-size: 14px;
    font-weight: 700;
    color: var(--text3);
}
.variant-qty-badge {
    font-size: 11px;
    color: var(--text11);
    background: #fff;
    border-radius: 20px;
    padding: 2px 8px;
    margin-left: auto;
}
.variant-pill {
    padding: 7px 18px;
    border: 2px solid var(--nonagenary);
    border-radius: 25px;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    color: var(--text9);
    cursor: pointer;
    transition: all 0.2s;
}
.variant-pill.active {
    border-color: var(--primary);
    background: rgba(232, 118, 43, 0.08);
    color: var(--primary);
}
.variant-pill.spicy.active {
    border-color: #dc3c1e;
    background: rgba(220, 60, 30, 0.08);
    color: #dc3c1e;
}

/* ========== RESUMEN ========== */
.summary-size-row {
    background: var(--octagenary);
    border-radius: 12px;
    padding: 10px 14px;
}
.summary-size-label {
    font-size: 15px;
    font-weight: 700;
    color: var(--text3);
}
.summary-price {
    font-size: 22px;
    font-weight: 800;
    color: var(--primary);
}
.summary-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
}
.summary-row {
    padding: 10px;
    border: 1px solid var(--nonagenary);
    border-radius: 12px;
}
.summary-thumb {
    width: 38px;
    height: 28px;
    object-fit: contain;
}
.summary-product {
    font-size: 14px;
    font-weight: 700;
    color: var(--text3);
}
.summary-spicy { font-size: 12px; margin-left: 4px; }
.summary-qty {
    font-size: 12px;
    color: var(--text11);
}
.summary-includes {
    font-size: 12px;
    color: var(--text11);
    padding: 8px 0;
    border-top: 1px solid var(--nonagenary);
}

/* ========== BOTONES ========== */
.btn-next {
    display: block;
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
}
.btn-next:hover { background: var(--vigequinary); }
.btn-next:active { transform: scale(0.97); }
.btn-next:disabled {
    background: var(--nonagenary);
    cursor: not-allowed;
}
.btn-back {
    display: block;
    width: 100%;
    padding: 10px;
    border: none;
    background: transparent;
    color: var(--text11);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
}
.btn-back:hover { color: var(--primary); }
.btn-cart {
    display: block;
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 17px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
}
.btn-cart:hover { background: var(--vigequinary); }
.btn-cart:active { transform: scale(0.97); }
.builder-left-footer {
    padding: 12px 16px;
    text-align: center;
    width: 100%;
}
.btn-reset-link {
    display: block;
    width: 100%;
    background: none;
    border: none;
    color: var(--text15);
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
    padding: 4px;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 400px) {
    .banner-title { font-size: 22px; }
    .banner-img { height: 70px; }
    .section-product-img { height: 42px; }
    .tercio-label { min-width: 50px; font-size: 11px; }
    .pill-img { width: 28px; height: 22px; }
    .pill-name { font-size: 9px; }
}
</style>
